import { OrganisationDataDto } from '@dhl/mdp-api'
import { convertToAddress } from '~/common/components/addresses'
import type { TerminalData } from '~/modules/terminals/model'
import { convertToContactPerson } from '~/common/model/contact'

export const convertToTerminalData = (terminalData: OrganisationDataDto): TerminalData => ({
  ...terminalData,
  address: convertToAddress(terminalData.address),
  contactPerson: convertToContactPerson(terminalData.contactPerson),
})
